import { Spinner } from '@gymcoach/ui';
import type { ReactNode } from 'react';

import { GymMark } from './GymMark';

/** Centered card for start-up and blocked states (signed out, not staff, deactivated). */
export function FullScreenMessage({
  title,
  children,
  actions,
}: {
  title: string;
  children?: ReactNode;
  actions?: ReactNode;
}) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-canvas px-4 py-10">
      <div className="w-full max-w-sm rounded-lg border bg-surface p-6 shadow-sm">
        <GymMark name="Fitnatic" logoUrl="/fitnatic-icon.svg" className="mb-5" />
        <h1 className="text-xl font-semibold text-ink">{title}</h1>
        {children && <div className="mt-2 text-sm text-ink-muted">{children}</div>}
        {actions && <div className="mt-5 flex flex-wrap gap-2">{actions}</div>}
      </div>
    </div>
  );
}

/** The first paint while the session and profile load: calm, branded, no layout jump. */
export function Splash({ label = 'Loading Fitnatic' }: { label?: string }) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-canvas">
      <GymMark name="Fitnatic" logoUrl="/fitnatic-icon.svg" />
      <Spinner size="md" label={label} />
    </div>
  );
}
